// Social Share - X (TW)
// popup that uses OG tags' content

import $ from 'jquery';

export default function (btn) {
  function init () {
    registerEvents();
  }

  function registerEvents () {
    btn.on('click', function (e) {
      e.preventDefault();

      let url = encodeURIComponent(window.location.href);
      let text = encodeURIComponent($('meta[name=\'twitter:description\']').attr('content'));
      let shareUrl = 'https://x.com/intent/tweet?text=' + text + '&url=' + url;

      window.open(shareUrl, '_blank', 'toolbar=yes, scrollbars=yes, resizable=yes, width=530, height=290');
    });
  }

  init();
}
